// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"31":"f5f2555f","148":"fe4fa42d","387":"f0289cef"}[chunkId] + ".css";
};